module.exports = __webpack_public_path__ + "vue_assets/img/img_membership_greatgm_masterclass.31bbd5b6.png";